import React from "react";
import {
  Card,
  CardBody,
  Typography,
  Button
} from "@material-tailwind/react";
import { ArrowLongRightIcon, MagnifyingGlassCircleIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";

export default function CiberSoccontent() {

 

  return (
    <>

      <div className="w-full mx-auto inline-block md:w-3/4 md:flex-row ">

<nav
    className="w-11/12 mx-auto mt-6 mb-2 text-sm text-gray-500 lg:w-full"
    aria-label="Breadcrumb"
  >
    <Link
      to="/Servicios-Ciberseguridad"
      className="hover:text-indigo-600 transition font-medium"
    >
      Ciberseguridad
    </Link>
    <span className="mx-2">›</span>
    <span className="text-gray-800">
      Detección — SOC / MDR
    </span>
  </nav>

    <div className="flex items-center gap-3 w-11/12 mx-auto mt-5 md:mt-0 lg:w-full mb-3">
                <MagnifyingGlassCircleIcon className="text-indigo-500 w-10 h-10 group-hover:text-white" />
        <Typography
           variant="h3"
           className="text-black font-sanz text-left"
         >
           
          Detección — SOC / MDR (Managed Detection & Response)
        </Typography>
          </div>

        <Typography
          className="w-11/12 mx-auto md:mt-0 text-left lg:w-full font-mono text-xl"
        >El Centro de Operaciones de Seguridad (SOC) supervisa en tiempo real tu entorno digital, correlacionando eventos, analizando anomalías y activando respuestas tempranas cuando corresponde. Bajo un modelo MDR que combina investigación especializada, threat hunting proactivo y automatización mediante SOAR, el servicio permite identificar y contener amenazas en el menor tiempo posible.<br/>
        <br/>Podemos operar sobre plataformas propias o integrarnos con las herramientas existentes en tu infraestructura (BYO-SIEM), asegurando visibilidad permanente y reduciendo la carga operativa. Este enfoque optimiza tiempos de reacción y refuerza la postura defensiva frente a amenazas emergentes.
        </Typography>
        <div className="flex flex-wrap justify-center gap-3 mt-10 md:justify-around">
          
          <Typography
          variant="h3"
          className="w-11/12 mx-auto mt-5 md:mt-0 lg:w-full mb-3 text-black font-sanz text-left"
        >Capacidades del servicio
        </Typography>
<Card className="mt-30 w-full">
            <div className=" group rounded-lg p-1 hover:bg-indigo-500 transition duration-300 ">
              <CardBody>
                {/* <ClipboardDocumentListIcon className="text-indigo-500 w-12 h-12 mb-4 group-hover:text-white" /> */}
                <Typography variant="h5" color="blue-gray" className="mb-2 group-hover:text-white">
                  Monitoreo y Detección 24/7/365
                </Typography>
                <Typography className="group-hover:text-white">

                <ul className="grid grid-cols-3 gap-2 mt-2 text-left">
  <li className="flex items-start gap-2">
    <span>•</span> Supervisión continua de logs, identidades, endpoints, nube y redes corporativas.
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Correlación en tiempo real con SIEM de última generación.
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Análisis de comportamiento con UEBA.
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Detección asistida por IA para reducir ruido y falsos positivos.
  </li>
</ul>
                </Typography>
              </CardBody>
              {/* <CardFooter className="pt-0">
                <Link to="/Contact/#form" className="inline-block">
                  <Button onClick= {() => {localStorage.setItem("ESP","CIB"); localStorage.setItem("SER","AAC")}} size="sm" variant="text" className="flex items-center gap-2 text-indigo-500 group-hover:text-white">
                    Conoce más sobre este servicio
                    <ArrowLongRightIcon strokeWidth={2} className="w-4 h-4 group-hover:text-white" />
                  </Button>
                </Link>
              </CardFooter> */}
            </div>
          </Card>

<Card className="mt-30 w-full">
            <div className=" group rounded-lg p-1 hover:bg-indigo-500 transition duration-300 ">
              <CardBody>
                {/* <ClipboardDocumentListIcon className="text-indigo-500 w-12 h-12 mb-4 group-hover:text-white" /> */}
                <Typography variant="h5" color="blue-gray" className="mb-2 group-hover:text-white">
                  Respuesta Gestionada (MDR)
                </Typography>
                <Typography className="group-hover:text-white">

                <ul className="grid grid-cols-3 gap-2 mt-2 text-left">
  <li className="flex items-start gap-2">
    <span>•</span> Activación inmediata de acciones de contención.
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Aislamiento de endpoints comprometidos.
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Bloqueo de comunicaciones maliciosas.
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Playbooks SOAR para automatizar respuestas repetitivas.
  </li>
  {/* <li className="flex items-start gap-2">
    <span>•</span> Detección asistida por IA para reducir ruido y falsos positivos.
  </li> */}
</ul>
                </Typography>
              </CardBody>
              {/* <CardFooter className="pt-0">
                <Link to="/Contact/#form" className="inline-block">
                  <Button onClick= {() => {localStorage.setItem("ESP","CIB"); localStorage.setItem("SER","AAC")}} size="sm" variant="text" className="flex items-center gap-2 text-indigo-500 group-hover:text-white">
                    Conoce más sobre este servicio
                    <ArrowLongRightIcon strokeWidth={2} className="w-4 h-4 group-hover:text-white" />
                  </Button>
                </Link>
              </CardFooter> */}
            </div>
          </Card>

<Card className="mt-30 w-full">
            <div className=" group rounded-lg p-1 hover:bg-indigo-500 transition duration-300 ">
              <CardBody>
                {/* <ClipboardDocumentListIcon className="text-indigo-500 w-12 h-12 mb-4 group-hover:text-white" /> */}
                <Typography variant="h5" color="blue-gray" className="mb-2 group-hover:text-white">
                  Threat Hunting Proactivo
                </Typography>
                <Typography className="group-hover:text-white">

                <ul className="grid grid-cols-3 gap-2 mt-2 text-left">
  <li className="flex items-start gap-2">
    <span>•</span> Búsqueda continua de TTPs basados en MITRE ATT&CK.
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Identificación de actividad que evade defensas tradicionales.
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Uso de reglas Sigma, YARA e indicadores enriquecidos (IOCs).
  </li>
  {/* <li className="flex items-start gap-2">
    <span>•</span> Playbooks SOAR para automatizar respuestas repetitivas.
  </li> */}
  {/* <li className="flex items-start gap-2">
    <span>•</span> Detección asistida por IA para reducir ruido y falsos positivos.
  </li> */}
</ul>
                </Typography>
              </CardBody>
              {/* <CardFooter className="pt-0">
                <Link to="/Contact/#form" className="inline-block">
                  <Button onClick= {() => {localStorage.setItem("ESP","CIB"); localStorage.setItem("SER","AAC")}} size="sm" variant="text" className="flex items-center gap-2 text-indigo-500 group-hover:text-white">
                    Conoce más sobre este servicio
                    <ArrowLongRightIcon strokeWidth={2} className="w-4 h-4 group-hover:text-white" />
                  </Button>
                </Link>
              </CardFooter> */}
            </div>
          </Card>
          
<Card className="mt-30 w-full">
            <div className=" group rounded-lg p-1 hover:bg-indigo-500 transition duration-300 ">
              <CardBody>
                {/* <ClipboardDocumentListIcon className="text-indigo-500 w-12 h-12 mb-4 group-hover:text-white" /> */}
                <Typography variant="h5" color="blue-gray" className="mb-2 group-hover:text-white">
                  BYO-SIEM / Integración Profunda
                </Typography>
                <Typography className="group-hover:text-white">

                <ul className="grid grid-cols-3 gap-2 mt-2 text-left">
  <li className="flex items-start gap-2">
    <span>•</span> Operamos sobre tu SIEM/XDR/EDR existente o lo optimizamos.
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Triaje avanzado, clasificación y priorización de alertas.
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Ajuste continuo de reglas y parsers personalizados.
  </li>
  {/* <li className="flex items-start gap-2">
    <span>•</span> Playbooks SOAR para automatizar respuestas repetitivas.
  </li> */}
  {/* <li className="flex items-start gap-2">
    <span>•</span> Detección asistida por IA para reducir ruido y falsos positivos.
  </li> */}
</ul>
                </Typography>
              </CardBody>
              {/* <CardFooter className="pt-0">
                <Link to="/Contact/#form" className="inline-block">
                  <Button onClick= {() => {localStorage.setItem("ESP","CIB"); localStorage.setItem("SER","AAC")}} size="sm" variant="text" className="flex items-center gap-2 text-indigo-500 group-hover:text-white">
                    Conoce más sobre este servicio
                    <ArrowLongRightIcon strokeWidth={2} className="w-4 h-4 group-hover:text-white" />
                  </Button>
                </Link>
              </CardFooter> */}
            </div>
          </Card>

           <Typography
          variant="h3"
          className="w-11/12 mx-auto mt-5 md:mt-0 lg:w-full mb-3 text-black font-sanz text-left"
        >Arquitectura del SOC
        </Typography>
<Card className="mt-30 w-full">
            <div className=" group rounded-lg p-1 hover:bg-indigo-500 transition duration-300 ">
              <CardBody>
                {/* <ClipboardDocumentListIcon className="text-indigo-500 w-12 h-12 mb-4 group-hover:text-white" /> */}
                <Typography variant="h5" color="blue-gray" className="mb-2 group-hover:text-white">
                  Plataforma Unificada
                </Typography>
                <Typography className="group-hover:text-white">

                <ul className="grid grid-cols-3 gap-2 mt-2 text-left">
  <li className="flex items-start gap-2">
    <span>•</span> SIEM: correlación de +500 fuentes con ingesta &lt;150 ms.
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> EDR/XDR: defensa avanzada en endpoints.
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> SOAR: automatización de hasta un 70% de incidentes Nivel 1.
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> IA Operacional: análisis, correlación y respuesta adaptativa.
  </li>
  {/* <li className="flex items-start gap-2">
    <span>•</span> Detección asistida por IA para reducir ruido y falsos positivos.
  </li> */}
</ul>
                </Typography>
              </CardBody>
              {/* <CardFooter className="pt-0">
                <Link to="/Contact/#form" className="inline-block">
                  <Button onClick= {() => {localStorage.setItem("ESP","CIB"); localStorage.setItem("SER","AAC")}} size="sm" variant="text" className="flex items-center gap-2 text-indigo-500 group-hover:text-white">
                    Conoce más sobre este servicio
                    <ArrowLongRightIcon strokeWidth={2} className="w-4 h-4 group-hover:text-white" />
                  </Button>
                </Link>
              </CardFooter> */}
            </div>
          </Card>

<Card className="mt-30 w-full">
            <div className=" group rounded-lg p-1 hover:bg-indigo-500 transition duration-300 ">
              <CardBody>
                {/* <ClipboardDocumentListIcon className="text-indigo-500 w-12 h-12 mb-4 group-hover:text-white" /> */}
                <Typography variant="h5" color="blue-gray" className="mb-2 group-hover:text-white">
                  Cobertura Multientorno
                </Typography>
                <Typography className="group-hover:text-white">

                <ul className="grid grid-cols-3 gap-2 mt-2 text-left">
  <li className="flex items-start gap-2">
    <span>•</span> Cloud: AWS, Azure, GCP.
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> On-premise: servidores, redes, endpoints.
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> OT/ICS: SCADA, Modbus, DNP3.
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> IoT: dispositivos industriales y sensores.
  </li>
  {/* <li className="flex items-start gap-2">
    <span>•</span> Detección asistida por IA para reducir ruido y falsos positivos.
  </li> */}
</ul>
                </Typography>
              </CardBody>
              {/* <CardFooter className="pt-0">
                <Link to="/Contact/#form" className="inline-block">
                  <Button onClick= {() => {localStorage.setItem("ESP","CIB"); localStorage.setItem("SER","AAC")}} size="sm" variant="text" className="flex items-center gap-2 text-indigo-500 group-hover:text-white">
                    Conoce más sobre este servicio
                    <ArrowLongRightIcon strokeWidth={2} className="w-4 h-4 group-hover:text-white" />
                  </Button>
                </Link>
              </CardFooter> */}
            </div>
          </Card>

<Card className="mt-30 w-full">
            <div className=" group rounded-lg p-1 hover:bg-indigo-500 transition duration-300 ">
              <CardBody>
                {/* <ClipboardDocumentListIcon className="text-indigo-500 w-12 h-12 mb-4 group-hover:text-white" /> */}
                <Typography variant="h5" color="blue-gray" className="mb-2 group-hover:text-white">
                  Integraciones Clave
                </Typography>
                <Typography className="group-hover:text-white">

                <ul className="grid grid-cols-3 gap-2 mt-2 text-left">
  <li className="flex items-start gap-2">
    <span>•</span> Splunk Enterprise Security (SIEM)
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Microsoft Sentinel / Defender (SIEM / XDR)
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Palo Alto Cortex XDR (XDR)
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Wazuh (HIDS)
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Trend Micro Vision One (XDR)
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> SentinelOne Singularity (XDR / EDR)
  </li>
</ul>
                </Typography>
              </CardBody>
              {/* <CardFooter className="pt-0">
                <Link to="/Contact/#form" className="inline-block">
                  <Button onClick= {() => {localStorage.setItem("ESP","CIB"); localStorage.setItem("SER","AAC")}} size="sm" variant="text" className="flex items-center gap-2 text-indigo-500 group-hover:text-white">
                    Conoce más sobre este servicio
                    <ArrowLongRightIcon strokeWidth={2} className="w-4 h-4 group-hover:text-white" />
                  </Button>
                </Link>
              </CardFooter> */}
            </div>
          </Card>

        <Typography
          variant="h3"
          className="w-11/12 mx-auto mt-5 md:mt-0 lg:w-full mb-3 text-black font-sanz text-left"
        >Operación, métricas y estándares del servicio
        </Typography>

<Card className="mt-30 w-full">
            <div className=" group rounded-lg p-1 hover:bg-indigo-500 transition duration-300 ">
              <CardBody>
                {/* <ClipboardDocumentListIcon className="text-indigo-500 w-12 h-12 mb-4 group-hover:text-white" /> */}
                <Typography variant="h5" color="blue-gray" className="mb-2 group-hover:text-white">
                  Métricas de rendimiento del SOC
                </Typography>
                <Typography className="group-hover:text-white">
                 Nuestro modelo operacional está respaldado por métricas verificables:
                <ul className="grid grid-cols-3 gap-2 mt-2 text-left">
  <li className="flex items-start gap-2">
    <span>•</span> MTTD: 5 minutos — detección promedio de incidentes críticos
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> MTTR: 30 minutos — tiempo promedio de contención y respuesta
  </li>
</ul>
                </Typography>
              </CardBody>
              {/* <CardFooter className="pt-0">
                <Link to="/Contact/#form" className="inline-block">
                  <Button onClick= {() => {localStorage.setItem("ESP","CIB"); localStorage.setItem("SER","AAC")}} size="sm" variant="text" className="flex items-center gap-2 text-indigo-500 group-hover:text-white">
                    Conoce más sobre este servicio
                    <ArrowLongRightIcon strokeWidth={2} className="w-4 h-4 group-hover:text-white" />
                  </Button>
                </Link>
              </CardFooter> */}
            </div>
          </Card>

<Card className="mt-30 w-full">
            <div className=" group rounded-lg p-1 hover:bg-indigo-500 transition duration-300 ">
              <CardBody>
                {/* <ClipboardDocumentListIcon className="text-indigo-500 w-12 h-12 mb-4 group-hover:text-white" /> */}
                <Typography variant="h5" color="blue-gray" className="mb-2 group-hover:text-white">
                  Modelo de Operación “Follow-the-Sun”
                </Typography>
                <Typography className="group-hover:text-white">
                 La vigilancia es ininterrumpida gracias a la coordinación entre SOCs en Chile, México, España y Brasil. Esto elimina ventanas de vulnerabilidad por cambio de turnos y mantiene un nivel constante de atención.
                </Typography>
              </CardBody>
              {/* <CardFooter className="pt-0">
                <Link to="/Contact/#form" className="inline-block">
                  <Button onClick= {() => {localStorage.setItem("ESP","CIB"); localStorage.setItem("SER","AAC")}} size="sm" variant="text" className="flex items-center gap-2 text-indigo-500 group-hover:text-white">
                    Conoce más sobre este servicio
                    <ArrowLongRightIcon strokeWidth={2} className="w-4 h-4 group-hover:text-white" />
                  </Button>
                </Link>
              </CardFooter> */}
            </div>
          </Card>

<Card className="mt-30 w-full">
            <div className=" group rounded-lg p-1 hover:bg-indigo-500 transition duration-300 ">
              <CardBody>
                {/* <ClipboardDocumentListIcon className="text-indigo-500 w-12 h-12 mb-4 group-hover:text-white" /> */}
                <Typography variant="h5" color="blue-gray" className="mb-2 group-hover:text-white">
                  Modelos de Servicio
                </Typography>
                <Typography className="group-hover:text-white">

                <ul className="grid grid-cols-3 gap-2 mt-2 text-left">
  <li className="flex items-start gap-2">
    <span>•</span> MDR Completo — Operación integral 24/7.
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Threat Hunting as a Service — Caza proactiva avanzada.
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Incident Response Retainer — SLA de 2 horas para incidentes críticos.
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> CTEM as a Service — Gestión continua de exposición a amenazas.
  </li>
</ul>
                </Typography>
              </CardBody>
              {/* <CardFooter className="pt-0">
                <Link to="/Contact/#form" className="inline-block">
                  <Button onClick= {() => {localStorage.setItem("ESP","CIB"); localStorage.setItem("SER","AAC")}} size="sm" variant="text" className="flex items-center gap-2 text-indigo-500 group-hover:text-white">
                    Conoce más sobre este servicio
                    <ArrowLongRightIcon strokeWidth={2} className="w-4 h-4 group-hover:text-white" />
                  </Button>
                </Link>
              </CardFooter> */}
            </div>
          </Card>
          
<Card className="mt-30 w-full">
            <div className=" group rounded-lg p-1 hover:bg-indigo-500 transition duration-300 ">
              <CardBody>
                {/* <ClipboardDocumentListIcon className="text-indigo-500 w-12 h-12 mb-4 group-hover:text-white" /> */}
                <Typography variant="h5" color="blue-gray" className="mb-2 group-hover:text-white">
                  Ingeniería de Detección y Automatización
                </Typography>
                <Typography className="group-hover:text-white">

                <ul className="grid grid-cols-3 gap-2 mt-2 text-left">
  <li className="flex items-start gap-2">
    <span>•</span> Reglas Sigma y KQL personalizadas.
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Enriquecimiento automático de alertas con IA.
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Playbooks SOAR con RPA para mitigar incidentes de forma automática.
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Desarrollo de parsers para fuentes propietarias.
  </li>
</ul>
                </Typography>
              </CardBody>
              {/* <CardFooter className="pt-0">
                <Link to="/Contact/#form" className="inline-block">
                  <Button onClick= {() => {localStorage.setItem("ESP","CIB"); localStorage.setItem("SER","AAC")}} size="sm" variant="text" className="flex items-center gap-2 text-indigo-500 group-hover:text-white">
                    Conoce más sobre este servicio
                    <ArrowLongRightIcon strokeWidth={2} className="w-4 h-4 group-hover:text-white" />
                  </Button>
                </Link>
              </CardFooter> */}
            </div>
          </Card>

<Card className="mt-30 w-full">
            <div className=" group rounded-lg p-1 hover:bg-indigo-500 transition duration-300 ">
              <CardBody>
                {/* <ClipboardDocumentListIcon className="text-indigo-500 w-12 h-12 mb-4 group-hover:text-white" /> */}
                <Typography variant="h5" color="blue-gray" className="mb-2 group-hover:text-white">
                  Frameworks y Estándares Aplicados
                </Typography>
                <Typography className="group-hover:text-white">

                <ul className="grid grid-cols-3 gap-2 mt-2 text-left">
  <li className="flex items-start gap-2">
    <span>•</span> MITRE ATT&CK
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> NIST SP 800-61R3
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> ISO 27001
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> ISO 27035
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Cyber Kill Chain
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> FIRST (miembros activos)
  </li>
</ul>
                </Typography>
              </CardBody>
              {/* <CardFooter className="pt-0">
                <Link to="/Contact/#form" className="inline-block">
                  <Button onClick= {() => {localStorage.setItem("ESP","CIB"); localStorage.setItem("SER","AAC")}} size="sm" variant="text" className="flex items-center gap-2 text-indigo-500 group-hover:text-white">
                    Conoce más sobre este servicio
                    <ArrowLongRightIcon strokeWidth={2} className="w-4 h-4 group-hover:text-white" />
                  </Button>
                </Link>
              </CardFooter> */}
            </div>
          </Card>

<Card className="mt-30 w-full">
            <div className=" group rounded-lg p-1 hover:bg-indigo-500 transition duration-300 ">
              <CardBody>
                {/* <ClipboardDocumentListIcon className="text-indigo-500 w-12 h-12 mb-4 group-hover:text-white" /> */}
                <Typography variant="h5" color="blue-gray" className="mb-2 group-hover:text-white">
                  Modelo Concierge
                </Typography>
                <Typography className="group-hover:text-white">
                  Un acompañamiento estratégico pensado para equipos ejecutivos:
                <ul className="grid grid-cols-3 gap-2 mt-2 text-left">
  <li className="flex items-start gap-2">
    <span>•</span> App móvil con panel personalizado
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Reportes ejecutivos mensuales
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Canal directo con analistas N2/N3
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Reuniones trimestrales de revisión y planificación
  </li>
</ul>
                </Typography>
              </CardBody>
            
            </div>
          </Card>

<div className=" group rounded-lg p-1 hover:bg-indigo-500 transition duration-300 ">
                <button>
<Link to="/Contact/#form" className="inline-block ">
                                    <Button onClick={() => { localStorage.setItem("ESP", "CIB"); localStorage.setItem("SER", "DPC") }} size="sm" variant="text" className="flex items-center gap-2 text-indigo-500 group-hover:text-white">
                                        Solicitar este servicio
                                        <ArrowLongRightIcon strokeWidth={2} className="w-4 h-4 group-hover:text-white" />
                                    </Button>
                                </Link>
                                </button>
         
          </div>
         
        </div>
      </div>
    </>
  );
}